import axios from "axios";
import i18n from "@lang/i18n";

export function getRoute(route) {
  let pro = process.env;

  return pro[`REACT_APP_API_URL_${route.toUpperCase()}`];
}

export function apiSend(url, method, data) {
  var res;

  switch (method) {
    case "get":
      res = getData(url, data);
      break;
    case "delete":
      res = deleteData(url, data);
      break;
    case "post":
      res = postData(url, data);
      break;
    case "put":
      res = putData(url, data);
      break;
    case "pdf":
      res = pdfData(url, data);
      break;
    case "upload":
      res = uploadData(url, data);
      break;

    default:
      break;
  }

  //je peux mettre a jour la session au niveau de fronted

  return res;
}
export function http() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL_MAIN,
    headers: {
      "Content-type": "application/json",
    },
  });

  // Request interceptor
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Language header
      const currentLang =
        i18n.language || localStorage.getItem("i18nLng") || "fr";
      const langMap = { en: "en", us: "en", fr: "fr", es: "es" };
      config.headers["lang"] = langMap[currentLang] || "fr";

      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
}
async function urlToFile(url, filename) {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type });
}

/**
 *
 * Endpoint: /product/upload/{id}/upload
 *
 * @param {number|string} productId
 * @param {Array} images - [{ file, preview, name }]
 * @returns {Promise<any>} API response
 */
export async function uploadProductImages(endpoint, dataFiles) {
  try {
    const formData = new FormData();

    for (let i = 0; i < dataFiles.length; i++) {
      const dataFile = dataFiles[i];
      let file = null;
      if (dataFile?.file instanceof File) {
        file = dataFile.file;
      } else if (
        dataFile?.preview &&
        (dataFile.preview.startsWith("http") ||
          dataFile.preview.startsWith("blob:"))
      ) {
        file = await urlToFile(dataFile.preview, dataFile.name);
      }

      if (!file) continue;
      formData.append("uploadFiles[]", file);
    }
    const response = await httpUpload().post(endpoint, formData);
    return response?.data;
  } catch (err) {
    console.error("❌ upload failed:", err);
    throw err;
  }
}
function httpUpload() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL_MAIN,
    headers: {
      "Content-type": "multipart/form-data",
    },
  });


  // Request interceptor
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Language header
      const currentLang =
        i18n.language || localStorage.getItem("i18nLng") || "fr";
      const langMap = { en: "en", us: "en", fr: "fr", es: "es" };
      config.headers["lang"] = langMap[currentLang] || "fr";

      return config;
    },
    (error) => Promise.reject(error)
  );

  return instance;
}
const postData = async (url, data) => {
  let res = [];
  try {
    res = await http().post(url, data);
  } catch (e) {
    console.log(e);
  }
  return res;
};

const uploadData = async (url, data) => {
  let res = [];
  try {
    res = await httpUpload().post(url, data);
  } catch (e) {
    console.log(e);
  }
  return res;
};
const putData = async (url, data) => {
  let res = [];
  try {
    res = await http().put(url, data);
  } catch (e) {
    console.log(e);
  }
  return res;
};
const getData = async (url, data) => {
  let res = [];
  try {
    res = await http().get(url, { params: data });
  } catch (e) {
    console.log(e);
  }
  return res;
};
const deleteData = async (url, param = "") => {
  let res = [];
  try {
    res = await http().delete(url, { params: param });
  } catch (e) {
    console.log(e);
  }
  return res;
};

export const getOptions = async (url) => {
  try {
    const response = await http().get(url);

    return response.data.result.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
};

export const autocomplete = async (url, inputValue) => {
  try {
    const response = await getData(url, { q: inputValue });
    return response.data.result.map((item) => ({
      value: item.id,
      label: item.name,
      ...item,
    }));
  } catch (e) {
    return [];
  }
};

export const pdfData = async (urlload, title) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL_MAIN + "" + urlload,
    {
      responseType: "blob", // **TRÈS IMPORTANT :** Indique qu'on attend une réponse binair
      headers: {
        "Content-type": "application/pdf",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );

  //[response.data], { type: 'application/pdf' }
  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = title + ".pdf"; // Specify the name for the downloaded file
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

